import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';

export function ThreeDotsLoading({ size = 8, color = '#27d089' }) {
  const dots = [0, 1, 2];

  return (
    <Container>
      {dots.map((index) => (
        <Dot
          key={index}
          style={{
            width: size,
            height: size,
            borderRadius: size / 2,
            backgroundColor: color,
            margin: `0 ${size / 3}px`,
            animationDelay: `${index * 0.2}s`,
          }}
        />
      ))}
    </Container>
  );
}

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.4);
    opacity: 0.4;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;

const Dot = styled.div`
  animation: ${pulseAnimation} 0.8s ease-in-out infinite;
`;
